
import React from 'react';

import PropTypes from 'prop-types';
import circleCheck from "../../../assets/images/circle-check.svg";
import pesoCycle from "../../../assets/images/peso-cycle.svg";

const RCLMeterIntroduction = ({redirectTo, url}) => {
  function onClick() {
    redirectTo(url);
  }

  return (
    <div className="ds-card _padding--xlarge" data-testid="rcl-meter-introduction-card">
      <section className="cardSection _paddingTop--none _textAlign_center _borderBottom_unset">
        <img width="100" height="100" src={pesoCycle} alt='Peso Cycle' />
        <p className="copy -darkBlue _fontSize--xlarge">
          Get access to additional funds with a
          <span className=" -primary"><b> Revolving Credit Line</b></span>
        </p>
      </section>
      <section className="cardSection _withColumns">
        <img className="_marginBottom--small" width="30" height="30" src={circleCheck} alt='Circle Check' />
        <div className="text">
          <h3 className="-darkBlue _marginLeft--normal _marginBottom--none">Easy access to your additional funds</h3>
          <p className="copy _marginLeft--normal">
            Get financing up to ₱5M credit for up to 6 months depending on your business revenue.
          </p>
        </div>
      </section>
      <section className="cardSection _withColumns">
        <img className="_marginBottom--small" width="30" height="30" src={circleCheck} alt='Circle Check' />
        <div className="text">
          <h3 className="-darkBlue _marginLeft--normal _marginBottom--none">
            Flexible rates
          </h3>
          <p className="copy _marginLeft--normal">
            Rates are as low as 1.74% per month and are subject to your company’s financial assessment.
          </p>
        </div>
      </section>
      <section className="cardSection _withColumns _borderBottom_unset">
        <img className="_marginBottom--small" width="30" height="30" src={circleCheck} alt='Circle Check' />
        <div className="text">
          <h3 className="-darkBlue _marginLeft--normal _marginBottom--none">
            Fast processing time
          </h3>
          <p className="copy _marginLeft--normal">
            The entire application process only takes a few days after you submit complete requirements.
          </p>
        </div>
      </section>
      <section className="cardSection">
        <button
          className="ds-btn --block -primary"
          onClick={onClick}
          data-path={url}
          data-testid='apply-rcl-now-button'
        >
          Apply for Revolving Credit Line
        </button>
      </section>
    </div>
  )
}

RCLMeterIntroduction.propTypes = {
  url: PropTypes.string.isRequired,
  redirectTo: PropTypes.func.isRequired,
}

export default RCLMeterIntroduction;



// WEBPACK FOOTER //
// ./src/features/home/components/RCLMeterIntroduction.js